var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 45,
    viewBox: "0 0 34 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1587 29.084C32.7888 37.9179 25.5131 44.9669 16.5882 44.9669C7.42678 44.9669 1.16445e-05 37.2904 1.16445e-05 28.3787C1.16445e-05 27.1875 -0.0213414 24.8069 1.76472 20.7904C2.8336 18.3867 3.50401 16.8767 3.88236 15.4963C4.09025 14.7377 4.49454 13.5324 5.64707 15.4963C6.32666 16.6543 6.35295 18.3198 6.35295 18.3198C6.35295 18.3198 8.88142 16.3795 10.5882 12.6728C13.0904 7.23872 11.094 3.99042 10.4118 1.7316C10.1757 0.950189 10.0274 -0.454164 11.6471 0.143365C13.2974 0.752365 17.6605 3.80654 19.9412 7.02572C23.1962 11.6201 24.353 16.0257 24.353 16.0257C24.353 16.0257 25.3952 14.7322 25.7647 13.3787C26.1821 11.8502 26.1882 10.3365 27.5292 11.9671C28.8046 13.5177 30.6987 16.4318 31.7647 19.2022C33.7004 24.2332 33.1587 29.084 33.1587 29.084Z",
    fill: "url(#paint0_linear_1_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5883 44.9668C10.2531 44.9668 5.11768 39.8313 5.11768 33.4962C5.11768 29.6737 6.65809 27.3529 9.86403 24.2057C11.9167 22.1906 13.838 19.7156 14.6545 18.0303C14.8153 17.6985 15.1811 15.9697 16.5916 17.9939C17.3316 19.0556 18.4915 20.9437 19.2353 22.555C20.5176 25.3332 20.8236 28.0256 20.8236 28.0256C20.8236 28.0256 22.0802 27.2851 22.9412 25.3785C23.2188 24.7641 23.78 22.4378 25.3488 24.7637C26.4999 26.4705 28.0813 29.5394 28.0589 33.4962C28.0589 39.8313 22.9232 44.9668 16.5883 44.9668Z",
    fill: "#FC9502"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7645 32.4375C18.3969 32.4375 18.3969 35.4603 20.4704 39.4963C21.8511 42.1838 19.7859 44.9669 16.7645 44.9669C13.7432 44.9669 12.1763 42.5177 12.1763 39.4963C12.1763 36.4751 15.1322 32.4375 16.7645 32.4375Z",
    fill: "#FCE202"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2",
    x1: 16.6131,
    y1: 45.0001,
    x2: 16.6131,
    y2: 0.0332475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4C0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9502"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.0dac3cc7bdb3b05837d7cac9ad3b7f82.svg";
export { ForwardRef as ReactComponent };